import axios, { AxiosRequestConfig } from "axios";
import { ADMIN_API_BASE } from "./adminApiConfig";

/** Nedelja 1–5 → datum izvlačenja YYYYMMDD (tabela ultra_w_{date}) */
export const weeklyDateByWeek = (week: number): string => {
  switch (week) {
    case 1:
      return "20260913";
    case 2:
      return "20260920";
    case 3:
      return "20260927";
    case 4:
      return "20261004";
    case 5:
      return "20261011";
    default:
      return "20260913";
  }
};

const getWinnersWeekly = async (week: number): Promise<any> => {
  try {
    const date = weeklyDateByWeek(week);
    const config: AxiosRequestConfig = {
      method: "GET",
      // url: `https://test-back.firebird.rs/api/ultra/winners-w`,
      url: `${ADMIN_API_BASE}/api/ultra/winners-w`,

      headers: {
        "Content-Type": "application/json",
      },
      params: {
        date,
      },
    };

    const response = await axios(config);
    const { data } = response;
    const { code } = data;

    if (code !== 200) {
      return [];
    }

    return data.data;
  } catch (error) {
    return [];
  }
};

export default getWinnersWeekly;
